import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=582a7a5e&scoped=true"
import script from "./OAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OAuth.vue?vue&type=style&index=0&id=582a7a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a7a5e",
  null
  
)

export default component.exports